export const BOARD_FLOOR_FLOOR_MIN = 1;
export const BOARD_FLOOR_FLOOR_MAX = 999;
export const BOARD_FLOOR_QUANTITY_MIN = 1;
export const BOARD_FLOOR_QUANTITY_MAX = 9999;
